import React, { useState } from 'react'
import { apiProviderInvoice, apiTypes } from 'ui/api'
import { sosToast } from 'ui/common/components/toast'
import { Card } from 'ui/components/common/card'
import { IconButton, solidIcons } from 'ui/components/common/icon'
import { Input } from 'ui/components/common/input'
import { Debug } from 'ui/components/dev'
import { t } from 'ui/components/i18n/i18n'
import { FC } from 'ui/FunctionalComponent'
import * as classes from './ProviderInvoiceNotes.module.scss'

export const ProviderInvoiceNotes: FC = (props: {
	brokerInvoice: apiTypes.BrokerInvoiceResponse
	providerInvoice: apiTypes.ProviderInvoiceResponse
	onUpdate: (notes?: string) => void
	tPrefix: string
}) => {
	const { brokerInvoice, providerInvoice, onUpdate, tPrefix } = props

	const [providerInvoiceNotes, setProviderInvoiceNotes] = useState<string>(
		providerInvoice?.notes,
	)

	const [editNotes, setEditNotes] = useState<boolean>(false)
	const [isLoading, setIsLoading] = useState<boolean>(false)

	const updateProviderInvoiceNotes = async (): Promise<void> => {
		setIsLoading(true)

		const updatedProviderInvoice = {
			...providerInvoice,
			notes: providerInvoiceNotes,
		}

		const invoiceNotesResponse = await apiProviderInvoice.updateProviderInvoice(
			providerInvoice.id,
			updatedProviderInvoice,
		)

		if (invoiceNotesResponse.error) {
			sosToast.sendApiErrorResponseToast(invoiceNotesResponse)
		} else {
			onUpdate(providerInvoiceNotes)
		}

		setIsLoading(false)
	}

	return (
		<Card
			className={classes.providerInvoiceNotes}
			title={
				<div className={classes.providerInvoiceNotesHeader}>
					<div>{t('providerInvoiceNotes', tPrefix)}</div>
					<div>
						{brokerInvoice?.invoiceStatus === 'review' ||
						brokerInvoice?.invoiceStatus === 'approved' ? (
							<IconButton
								icon={!editNotes ? solidIcons.faPencilAlt : solidIcons.faCheck}
								color={editNotes ? 'green' : 'black'}
								spin={isLoading}
								iconClassName={classes.editSaveIcon}
								onClick={async () => {
									if (editNotes) {
										await updateProviderInvoiceNotes()
									}
									setEditNotes(!editNotes)
								}}
								testId={'customer-invoice-edit-save'}
							></IconButton>
						) : null}
					</div>
				</div>
			}
			color={'darkBlue'}
			fillHeight={true}
			testId={'customer-invoice-parent-card'}
		>
			<div>
				<Input
					value={providerInvoiceNotes}
					onChange={(newVal: string) => setProviderInvoiceNotes(newVal)}
					autofocus={editNotes}
					readOnly={!editNotes}
					multiline={true}
					width={'100%'}
				/>
			</div>
			<Debug data={providerInvoice} label='providerInvoice' />
		</Card>
	)
}
